import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { UserContext } from './UserContext'; // Import UserContext
import './Register.css'; // Separate CSS for register component
import MainLogo from "./mainlogo.svg";

const Register = () => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const { registerUser, isLoading } = useContext(UserContext); // Use registerUser and isLoading from context
    const navigate = useNavigate(); // Hook from React Router to navigate programmatically

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        try {
            await registerUser(email, password, name);
            navigate('/login'); // Navigate to login page after successful registration
        } catch (err) {
            setError(err.message || 'Registration failed.');
        }
    };

    return (
        <div className="register-container">
            <center className="inner-register-container">
                <img style={{ width: "60px" }} src={MainLogo} alt="Logo" />
                <h2>Register</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label style={{ float: "left" }}>Name</label><br />
                        <div className="input-icon">
                            <i className="fa fa-user"></i>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label style={{ float: "left" }}>Email</label><br />
                        <div className="input-icon">
                            <i className="fa fa-envelope"></i>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label style={{ float: "left" }}>Password</label><br />
                        <div className="input-icon">
                            <i className="fa fa-lock"></i>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label style={{ float: "left" }}>Confirm Password</label><br />
                        <div className="input-icon">
                            <i className="fa fa-lock"></i>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    {error && <div className="error">{error}</div>}
                    <button type="submit" disabled={isLoading}>
                        {isLoading ? 'Registering...' : 'Register'}
                    </button>
                </form>
                <div className="login-link">
                    <p>Already have an account? <Link to="/login">Login here</Link></p>
                </div>
            </center>
        </div>
    );
};

export default Register;
